import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicLegals from "./DynamicLegals";
import { FaEnvelope } from "react-icons/fa";
import { useWebData } from "../../Context/webDataContext";
import logo from '../../aseets/logo.svg'
import { resolvePlayStoreUrl } from "../../constants/storeLinks";

function Footer() {
  const location = useLocation();
  const navigate = useNavigate();
  const { getFooterData } = useWebData();

  const [footerData, setFooterData] = useState({
    appStoreUrl: "",
    bottomText: "" || "© 2025 Maideaze. All rights reserved.",
    email: "",
    footerLogo: "" || logo,
    navigationLinks: [],
    notificationContent: "",
    otherLinks: [],
    playStoreUrl: "",
    socialMediaIcons: [],
  });

  const [, setIsMobileMenuOpen] = useState(false);

  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  // Function to handle smooth scrolling or navigation
  const handleNavLinkClick = (sectionId) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
      }, 500);
    } else {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
    }
    closeMobileMenu();
  };

  // Fetch footer data from cached context
  useEffect(() => {
    const fetchFooterData = async () => {
      try {
        const data = await getFooterData();
        if (data) {
          setFooterData(data);
        } else {
          console.log("No footer data available.");
        }
      } catch (error) {
        console.error("Error fetching footer data: ", error);
      }
    };

    fetchFooterData();
  }, [getFooterData]);

  return (
    <footer className="pt-4 md:pt-10 px-4 lg:px-20">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 mb-10">
        {/* Column 1: Company */}
        <div>
          <h3 className="text-xl md:text-lg font-semibold  mb-4">Company</h3>
          <ul className="space-y-3">
            {footerData.navigationLinks?.map((link, index) => (
              <li key={index}>
                <button
                  onClick={() => handleNavLinkClick(link.section)}
                  className="hover:text-[#08875D] transition-all duration-200 cursor-pointer"
                >
                  {link.item}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Column 2: Others */}
        <div>
          <h3 className="text-xl md:text-lg font-semibold  mb-4">Others</h3>
          <ul className="space-y-3">
            {footerData.otherLinks?.map((link, index) => (
              <li key={index}>
                <a
                  href={link.href || "#"}
                  onClick={(e) => {
                    if (!link.href) {
                      e.preventDefault();
                      handleNavLinkClick(link.section);
                    }
                  }}
                  className="hover:text-[#08875D] transition-all duration-200 cursor-pointer"
                >
                  {link.item}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Column 3: Legals */}
        <div>
        <h3 className="text-xl md:text-lg font-semibold  mb-4">Legals</h3>
          <DynamicLegals />
        </div>

        {/* Column 4: Download App */}
        <div>
        <h3 className="text-xl md:text-lg font-semibold  mb-4">Download App</h3>
          <div className="flex flex-col space-y-3">
            <a
              href={resolvePlayStoreUrl(footerData.playStoreUrl)}
              aria-label="Download on Google Play"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Google Play Store"
                className="h-12 w-32 transform hover:scale-105 transition-all duration-200"
              />
            </a>
            <a href={footerData.appStoreUrl} aria-label="Download on the App Store">
              <img
                src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                alt="App Store"
                className="h-12 w-32 transform hover:scale-105 transition-all duration-200"
              />
            </a>
          </div>
        </div>

        {/* Column 5: Contact Us */}
        <div>
        <h3 className="text-xl md:text-lg font-semibold  mb-4">
              Contact Us{" "}
            </h3>
            <div className="mb-4 text-gray-600 flex items-center gap-2">
              <div className="flex items-center gap-2">
                <FaEnvelope />
                <span>{footerData.email}</span>
              </div>
         
         
          </div>
          <h3 className="text-xl md:text-lg font-semibold  mb-4">Follow Us</h3>
          <div className="flex items-center space-x-4">
            {footerData.socialMediaIcons?.map((icon, index) => (
              <a key={index} href={icon.url} aria-label={icon.url} target="_blank" rel="noopener noreferrer">
                <img
                  src={icon.iconUrl}
                  alt="Social Media Icon"
                  className="w-6 h-6 transition-all duration-200 transform hover:scale-110"
                />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-400 py-4">
        <div className="flex flex-col sm:flex-row items-center justify-between">
          <div className="flex items-center gap-2 mb-4 sm:mb-0">
            <img src={footerData.footerLogo} alt="Footer Logo" className="h-10 w-auto object-contain" />
          </div>
          <div className="text-gray-800 text-sm">{footerData.bottomText}</div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;


// // src/components/footer/Footer.js
// import React, { useState } from "react";
// import { useLocation, useNavigate, Link } from "react-router-dom";
// import logo from "../../aseets/logo.svg"
// import DynamicLegals from "./DynamicLegals";

// function Footer() {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [isOpen, setIsOpen] = useState(false);
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

//   const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
//   const toggleMenu = () => setIsOpen(!isOpen);
//   const closeMobileMenu = () => setIsMobileMenuOpen(false);

//   const handleNavLinkClick = (sectionId) => {
//     if (location.pathname !== "/") {
//       navigate("/");
//       setTimeout(() => {
//         const element = document.getElementById(sectionId);
//         if (element) {
//           element.scrollIntoView({ behavior: "smooth" });
//         }
//       }, 500);
//     } else {
//       const element = document.getElementById(sectionId);
//       if (element) {
//         element.scrollIntoView({ behavior: "smooth" });
//       }
//     }
//     closeMobileMenu();
//   };

//   return (
//     <footer className="bg-white border-t border-gray-200 pt-10 px-6 lg:px-16">
//       <div className="">
//         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 mb-10">
//           {/* Column 1: Company */}
//           <div>
//             <h3 className="text-lg font-semibold text-gray-900 mb-4">
//               Company
//             </h3>
//             <ul className="space-y-5 text-gray-600">
//               <li>
//                 <a onClick={() => handleNavLinkClick("about")}>About Us</a>
//               </li>
//               <li>
//                 <a onClick={() => handleNavLinkClick("services")}>Services</a>
//               </li>
//               <li>
//                 <a onClick={() => handleNavLinkClick("how-it-works")}>
//                   How It Works
//                 </a>
//               </li>
//               <li>
//                 <a onClick={() => handleNavLinkClick("service-providers")}>
//                   For Service Providers
//                 </a>
//               </li>
//             </ul>
//           </div>

//           {/* Column 2: Others */}
//           <div>
//             <h3 className="text-lg font-bold text-gray-900 mb-4">Others</h3>
//             <ul className="space-y-5 text-gray-600">
//               <li>
//                 <a href="#">Testimonials</a>
//               </li>
//               <li>
//                 <a onClick={() => handleNavLinkClick("faqs")}>FAQs</a>
//               </li>
//               <li>
//                 <a href="/blog">Blogs</a>
//               </li>
//               <li>
//                 <a href="/contact">Contact Us</a>
//               </li>
//             </ul>
//           </div>

//           {/* Column 3: Legals */}
//           <div>
//             <h3 className="text-lg font-bold text-gray-900 mb-4">Legals</h3>
//             <DynamicLegals />
//           </div>

//           {/* Column 4: Download App */}
//           <div>
//             <h3 className="text-lg font-bold text-gray-900 mb-4">
//               Download App
//             </h3>
//             <div className="flex flex-col space-y-4">
//               <a href="#" aria-label="Download on Google Play" className="w-[10rem]">
//                 <img
//                   src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Google_Play_Store_badge_EN.svg/512px-Google_Play_Store_badge_EN.svg.png"
//                   alt="Google Play Store"
//                   className="h-10 object-contain w-[7.4rem]"
//                 />
//               </a>
//               <a href="#" aria-label="Download on the App Store" className="w-[10rem]">
//                 <img
//                   src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
//                   alt="App Store"
//                   className="h-10 object-contain w-[7.5rem]"
//                 />
//               </a>
//             </div>
//           </div>

//           {/* Column 5: Contact Us */}
//           <div>
//             <h3 className="text-lg font-bold text-gray-900 mb-4">Contact Us</h3>
//             <div className="mb-4 text-gray-600 flex items-center gap-2">
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 className="w-5 h-5 text-gray-500"
//                 viewBox="0 0 20 20"
//                 fill="currentColor"
//               >
//                 <path d="M2 3a2 2 0 012-2h12a2 2 0 012 2v1l-8 5-8-5V3z" />
//                 <path d="M2 8l8 5 8-5v7a2 2 0 01-2 2H4a2 2 0 01-2-2V8z" />
//               </svg>
//               <span>hello@maideaze.com</span>
//             </div>
//             <h3 className="text-lg font-bold text-gray-900 mb-2">Follow Us</h3>
//             <div className="flex items-center space-x-3">
//               <a href="#" aria-label="LinkedIn">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   fill="currentColor"
//                   viewBox="0 0 16 16"
//                   className="w-5 h-5 text-gray-500 hover:text-gray-700"
//                 >
//                   <path d="M0 1.146C0 .513.324 0 .722 0h14.556c.398 0 .722.513.722 1.146v13.708c0 .633-.324 1.146-.722 1.146H.722C.324 16 0 15.487 0 14.854V1.146zM4.943 13.5V6H3V13.5h1.943zM3.97 5h.011c.654 0 1.078-.447 1.078-1.007 0-.573-.434-1.006-1.101-1.006-.667 0-1.078.433-1.078 1.006 0 .56.423 1.007 1.067 1.007zM13.5 13.5h-1.943V9.75c0-.895-.32-1.506-1.12-1.506-.612 0-.976.412-1.137.81-.059.145-.073.347-.073.55v3.896H7.286s.026-6.324 0-6.978h1.943v.99c.257-.396.716-.96 1.742-.96 1.273 0 2.529.835 2.529 2.632v4.316z" />
//                 </svg>
//               </a>
//               <a href="#" aria-label="Instagram">
//                 <svg
//                   viewBox="0 0 24 24"
//                   fill="currentColor"
//                   className="w-5 h-5 text-gray-500 hover:text-gray-700"
//                 >
//                   <path d="M7.001 2C4.239 2 2 4.239 2 7.001v9.998C2 19.761 4.239 22 7.001 22h9.998C19.761 22 22 19.761 22 17v-10c0-2.761-2.239-5-5.001-5H7.001zM12 7.315A4.685 4.685 0 0116.685 12 4.685 4.685 0 0112 16.685 4.685 4.685 0 017.315 12 4.685 4.685 0 0112 7.315zM17.807 5.36a1.077 1.077 0 110 2.155 1.077 1.077 0 010-2.155zM12 8.73A3.273 3.273 0 008.73 12 3.273 3.273 0 0012 15.27 3.273 3.273 0 0015.27 12 3.273 3.273 0 0012 8.73z" />
//                 </svg>
//               </a>
//               <a href="#" aria-label="X Twitter">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   fill="currentColor"
//                   className="w-5 h-5 text-gray-500 hover:text-gray-700"
//                   viewBox="0 0 24 24"
//                 >
//                   <path d="M18.244 5.247h-2.648l-3.07 4.692-3.07-4.692H6.808l4.46 6.685-4.707 6.969h2.63l3.376-4.995 3.377 4.995h2.61l-4.685-6.956 4.375-6.698z" />
//                 </svg>
//               </a>
//               <a href="#" aria-label="Facebook">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   fill="currentColor"
//                   className="w-5 h-5 text-gray-500 hover:text-gray-700"
//                   viewBox="0 0 24 24"
//                 >
//                   <path d="M22.675 0h-21.35C.596 0 0 .596 0 1.332v21.337c0 .737.596 1.332 1.325 1.332h11.494v-9.283H9.847V12h2.973V9.412c0-2.937 1.793-4.539 4.416-4.539 1.255 0 2.336.093 2.649.134v3.069l-1.819.001c-1.429 0-1.708.678-1.708 1.677V12h3.415l-.446 3.718h-2.969V24h5.828c.73 0 1.325-.596 1.325-1.332V1.332C24 .596 23.405 0 22.675 0z" />
//                 </svg>
//               </a>
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* Bottom Bar */}
//       <div className="border-t border-gray-200 py-4 ">
//         <div className="flex flex-col sm:flex-row items-center justify-between">
//           <div className="flex items-center gap-2 mb-4 sm:mb-0">
//             <img src={logo} alt="maideaze logo" />
//           </div>
//           <div className="text-gray-500 text-sm">
//             © 2025 Maideaze. All rights reserved.
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// }

// export default Footer;
